import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavLink,
  NavItem,
  Spinner,
  Table,
  Button,
  Input,
  // PaginationLink,
  // PaginationItem,
  // Pagination,
  Label,
  Badge,
} from "reactstrap"
import ButtonSpinner from "components/ButtonSpinner"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import Modal from "react-bootstrap/Modal"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
//Import Styles
import "./styles.scss"
//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as yearWiseEventsAction from "../../store/eWVhcldpc2VFdmVudHM/actions"
import api from "helpers/Api"
import * as eventClientAction from "../../store/bXl3b3Jrc3Bob3Rv/actions"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

const YearWiseEventsRecord = (props) => {
  const title = "Year Wise Events Record"
  const { dispatch, searchBarStyle } = props

  //Year and month format
  const currentYear = moment().format("YYYY")
  const nextYear = moment().add(1, "years").format("YYYY")
  const prevYear = moment().subtract(1, "years").format("YYYY")
  // const nextYear = parseInt(currentYear + 1)
  // console.log(prevYear, "prevYear")

  // console.log(nextYear, "nextYear")
  const currentMonthDetails = moment().format("MM")
  const currentMonthList = moment().format("MMMM")

  const currentMonth =
    (!isEmpty(currentMonthList) && currentMonthList === "June") ||
      (!isEmpty(currentMonthList) && currentMonthList === "July")
      ? currentMonthList
      : currentMonthList.slice(0, 3)

  useEffect(() => {
    dispatch(
      yearWiseEventsAction.loadEventCompleteList({
        year: currentYear,
        month: currentMonthDetails,
        page: 1,
        limit: 100,
      })
    )
    setPageNumber("1")
    dispatch(yearWiseEventsAction.loadRecordsMetaData())
    setBtnLoading(true)
    setTimeout(() => {
      // setEventLoading(true)
      setBtnLoading(false)
    }, 5000)
  }, [])

  //Reducer store state maintenance
  const eventCompleteUpdate = useSelector((state) => state.yearWiseEvents)

  const { recordsMetaData = {}, event_complete_details = [] } =
    eventCompleteUpdate

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate
  // console.log(recordsMetaData, "recordsMetaData")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //State maintenance section
  const [customIconActiveTab, setCustomIconActiveTab] = useState(currentMonth)
  const [customIconActiveYear, setCustomIconActiveYear] = useState(currentYear)
  const [monthDetails, setMonthDetails] = useState("")
  const [eventDate, setEventDate] = useState("")
  // const [paginationList, setPaginationList] = useState("")
  const [pageNumber, setPageNumber] = useState("")
  const [serviceDetailsData, setServiceDetailsData] = useState([])
  const [serviceDetailsDataSet, setServiceDetailsDataSet] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const [pageSelected, setPageSelected] = useState(false)
  // const [eventLoading, setEventLoading] = useState(false)

  //Reset fucntinalities
  const [isFreelancer, setIsFreelancer] = useState("")
  const [employee, setEmployee] = useState([])
  // const [eventFromDate, setEventFromDate] = useState("")
  const [eventToDate, setEventToDate] = useState("")
  const [resetEmployee, setResetEmployee] = useState(false)

  //Freelancer list
  const statusList = [
    {
      label: "Is Freelancer",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked
    // console.log(e, "value")
    // console.log("chooseData handle isChecked ", isChecked)
    if (isChecked) {
      setIsFreelancer(value)
      // setAuditChecked(true)
    } else {
      setIsFreelancer(false)
    }
    // console.log("choose value", value)
  }

  const handleOnClear = () => {
    setEmployee([])
  }

  // onClear={handleOnClear}

  const resetForm = () => {
    setEmployee([])
    setResetEmployee(true)
    setEventDate("")
    setBtnLoading(true)
    // setSearchValueList({})
    setIsFreelancer(false)
    // setEventFromDate("")
    setEventToDate("")
    api
      .post("/list_lead_event_monthly_report", {
        year: currentYear,
        month: currentMonthDetails,
        page: 1,
        limit: 100,
      })
      .then((res) => {
        // let paginationNumber =
        //   !isEmpty(res.data.data) && res.data.data !== undefined
        //     ? res.data.data.totalPage
        //     : "--"

        // const startPage =
        //   res.data.data.currentPage == 1
        //     ? paginationNumber - res.data.data.currentPage
        //     : parseInt(paginationNumber - res.data.data.currentPage + 1)

        // const result = [res.data.data.currentPage, paginationNumber]

        // const range = (start, end) => {
        //   return Array(end - start + 1)
        //     .fill()
        //     .map((_, idx) => start + idx)
        // }
        // const pagingNumber = !isEmpty(result)
        //   ? range(startPage, paginationNumber)
        //   : "--"

        // const pageNumber = startPage == 0 ? [1] : pagingNumber

        // setPaginationList(pageNumber)
        const eventFilterDataTable = !isEmpty(res.data.data)
          ? res.data.data.data.map((eventData, index) => {
            // slNo = slNo + 1

            const eventDate =
              !isEmpty(eventData.eventDate) && eventData.eventDate
                ? moment(eventData.eventDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(dateFormate)
                : ""

            if (
              !isEmpty(eventData) &&
              !isEmpty(eventData.serviceDetail) &&
              eventData.serviceDetail.length > 0 &&
              !serviceDetailsDataSet
            ) {
              setServiceDetailsData(eventData.serviceDetail)
              setServiceDetailsDataSet(true)
            }
            // console.log(service, "service")

            return {
              _id: eventData._id,
              sNo: index + 1,
              leadNo: eventData.leadNo,
              clientName: eventData.clientName,
              clientType:eventData.clientType,
              clientCode: eventData.clientCode,
              bride: eventData.brideName,
              groom: eventData.groomName,
              eventDate: eventDate,
              eventDateDetails: eventData.eventDate,
              eventType: eventData.eventName,
              priorityStatusId: eventData.priorityStatusId,
              priorityStatusName: eventData.priorityStatusName,
              startTime: eventData.startTime,
              endTime: eventData.endTime,
              food: eventData.food,
              travelStay: eventData.travelStay,
              venue: eventData.venueName,
              location: eventData.venueLocation,
              companyId: eventData.companyId,
              ecAgentName: eventData.ecAgentName,
              companyName: eventData.companyName,
              branchId: eventData.branchId,
              branchName: eventData.branchName,
              salesAgent: eventData.salesAgent,
              serviceDetail: eventData.serviceDetail,
              shootType: eventData.shootType,
              key: index,
            }
          })
          : []
        setTimeout(() => {
          setEventDataTable(eventFilterDataTable)
          setBtnLoading(false)
        }, 2000)
        return res.data
      })
      .catch((error) => Promise.reject(error))

    setTimeout(() => {
      setResetEmployee(false)
    }, 500)
  }

  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  // console.log(event_complete_details, "event_complete_details")
  //data table for manageEc
  let slNo = 0
  const eventDataTable = !isEmpty(event_complete_details)
    ? event_complete_details.data.map((eventData, index) => {
      slNo = slNo + 1

      const eventDate =
        !isEmpty(eventData.eventDate) && eventData.eventDate
          ? moment(eventData.eventDate)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(dateFormate)
          : ""

      if (
        !isEmpty(eventData) &&
        !isEmpty(eventData.serviceDetail) &&
        eventData.serviceDetail.length > 0 &&
        !serviceDetailsDataSet
      ) {
        setServiceDetailsData(eventData.serviceDetail)
        setServiceDetailsDataSet(true)
      }
      // console.log(service, "service")

      return {
        _id: eventData._id,
        sNo: slNo,
        leadNo: eventData.leadNo,
        name: eventData.clientName,
        clientCode: eventData.clientCode,
        bride: eventData.brideName,
        groom: eventData.groomName,
        eventDate: eventDate,
        eventDateDetails: eventData.eventDate,
        eventType: eventData.eventName,
        priorityStatusId: eventData.priorityStatusId,
        priorityStatusName: eventData.priorityStatusName,
        startTime: eventData.startTime,
        endTime: eventData.endTime,
        food: eventData.food,
        travelStay: eventData.travelStay,
        venue: eventData.venueName,
        location: eventData.venueLocation,
        companyId: eventData.companyId,
        ecAgentName: eventData.ecAgentName,
        companyName: eventData.companyName,
        branchId: eventData.branchId,
        branchName: eventData.branchName,
        salesAgent: eventData.salesAgent,
        serviceDetail: eventData.serviceDetail,
        shootType: eventData.shootType,
        key: index,
      }
    })
    : []

  // const [searchValueList, setSearchValueList] = useState("")

  const applyFilter = (e) => {
    e.preventDefault()
    var searchEmployee = employee && employee ? employee.empCode : ""
    var searchEventDate = eventDate
      ? moment(eventDate).format("YYYY-MM-DD")
      : ""
    var searchFreelancer = isFreelancer == true ? true : false
    var searchEventDateYear = eventDate
      ? moment(eventDate).format("YYYY")
      : !isEmpty(monthDetails)
        ? monthDetails.year
        : currentYear
    var searchEventDateMonth = eventDate
      ? moment(eventDate).format("MM")
      : !isEmpty(monthDetails)
        ? monthDetails.value
        : currentMonthDetails
    // var searchEventFromDate = eventFromDate
    //   ? moment(eventFromDate).format("YYYY-MM-DD")
    //   : ""
    var searchEventToDate = eventToDate
      ? moment(eventToDate).format("YYYY-MM-DD")
      : ""

    var searchValue = {}
    searchValue.page = 1
    searchValue.limit = 100
    if (searchEmployee) {
      searchValue.employeeCode = searchEmployee
    }
    if (searchFreelancer) {
      searchValue.isFreelancer = searchFreelancer
    }
    if (searchEventDate) {
      searchValue.date = searchEventDate
    }
    // if (searchEventFromDate) {
    //   searchValue.eventFromDate = searchEventFromDate
    // }
    if (searchEventToDate) {
      searchValue.eventToDate = searchEventToDate
    }
    if (searchEventDateYear) {
      searchValue.year = searchEventDateYear
    }
    if (searchEventDateMonth) {
      searchValue.month = searchEventDateMonth
    }

    // setSearchValueList(searchValue)

    api
      .post("/list_lead_event_monthly_report", searchValue)
      .then((res) => {
        // let paginationNumber =
        //   !isEmpty(res.data.data) && res.data.data !== undefined
        //     ? res.data.data.totalPage
        //     : "--"

        // const startPage =
        //   res.data.data.currentPage == 1
        //     ? paginationNumber - res.data.data.currentPage
        //     : parseInt(paginationNumber - res.data.data.currentPage + 1)

        // const result = [res.data.data.currentPage, paginationNumber]

        // const range = (start, end) => {
        //   return Array(end - start + 1)
        //     .fill()
        //     .map((_, idx) => start + idx)
        // }
        // const pagingNumber = !isEmpty(result)
        //   ? range(startPage, paginationNumber)
        //   : "--"

        // console.log(startPage, "startPage")
        // const pageNumber =
        //   startPage == 0 || startPage == -1 || paginationNumber == 0
        //     ? [1]
        //     : pagingNumber

        // setPaginationList(pageNumber)
        const eventFilterDataTable = !isEmpty(res.data.data)
          ? res.data.data.data.map((eventData, index) => {
            // slNo = slNo + 1

            const eventDate =
              !isEmpty(eventData.eventDate) && eventData.eventDate
                ? moment(eventData.eventDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(dateFormate)
                : ""

            if (
              !isEmpty(eventData) &&
              !isEmpty(eventData.serviceDetail) &&
              eventData.serviceDetail.length > 0 &&
              !serviceDetailsDataSet
            ) {
              setServiceDetailsData(eventData.serviceDetail)
              setServiceDetailsDataSet(true)
            }
            // console.log(service, "service")

            return {
              _id: eventData._id,
              sNo: index + 1,
              leadNo: eventData.leadNo,
              name: eventData.clientName,
              bride: eventData.brideName,
              clientCode: eventData.clientCode,
              groom: eventData.groomName,
              eventDate: eventDate,
              clientType:eventData.clientType,
              eventDateDetails: eventData.eventDate,
              eventType: eventData.eventName,
              priorityStatusId: eventData.priorityStatusId,
              priorityStatusName: eventData.priorityStatusName,
              startTime: eventData.startTime,
              endTime: eventData.endTime,
              food: eventData.food,
              travelStay: eventData.travelStay,
              venue: eventData.venueName,
              location: eventData.venueLocation,
              companyId: eventData.companyId,
              ecAgentName: eventData.ecAgentName,
              companyName: eventData.companyName,
              branchId: eventData.branchId,
              branchName: eventData.branchName,
              salesAgent: eventData.salesAgent,
              serviceDetail: eventData.serviceDetail,
              shootType: eventData.shootType,
              key: index,
            }
          })
          : []
        setTimeout(() => {
          setEventDataTable(eventFilterDataTable)
        }, 2000)
        return res.data
      })
      .catch((error) => Promise.reject(error))

    // dispatch(yearWiseEventsAction.loadEventCompleteList(searchValue))
    setBtnLoading(true)
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 3000)
  }

  //Data table andsorting functionality

  const [eventsDataTable, setEventDataTable] = useState("")
  const [eventPageLoad, setEventPagePageLoad] = useState(false)

  if (!isEmpty(eventDataTable) && eventDataTable.length > 0 && !eventPageLoad) {
    setEventPagePageLoad(true)
    setEventDataTable(eventDataTable)
  }

  // console.log(eventsDataTable, "eventsDataTable")
  // console.log(eventDataTable, "eventDataTable")
  const [sortDirection, setSortDirection] = useState("asc")
  const handleDateSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = new Date(a.eventDateDetails)
      const dateB = new Date(b.eventDateDetails)
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }

  const handleLeadSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.leadNo
      const dateB = b.leadNo
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleNameSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.name
      const dateB = b.name

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleClientCodeSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.clientCode
      const dateB = b.clientCode

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleBrideSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.bride
      const dateB = b.bride

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleGroomSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.groom
      const dateB = b.groom
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleEventSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.eventType
      const dateB = b.eventType
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handlePrioritySort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.priorityStatusName
      const dateB = b.priorityStatusName
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleVenueSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.venue
      const dateB = b.venue
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleFoodSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.food
      const dateB = b.food
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleTravelSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.travelStay
      const dateB = b.travelStay
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleLocationSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.location
      const dateB = b.location
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleCompanySort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      // console.log(a, b, "name")
      const dateA = a.companyName
      const dateB = b.companyName

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleBranchSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      // console.log(a, b, "name")
      const dateA = a.branchName
      const dateB = b.branchName

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleSalesSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      // console.log(a, b, "name")
      const dateA = a.salesAgent
      const dateB = b.salesAgent
      // console.log(dateA, "dateA")
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleEcSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      // console.log(a, b, "name")
      const dateA = a.ecAgentName
      const dateB = b.ecAgentName
      // console.log(dateA, "dateA")
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }

  const handleSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = new Date(a.eventDateDetails)
      const dateB = new Date(b.eventDateDetails)
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA
    })

    // console.log(sortedData, "sortedData")

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }


  let tabs = [
    { value: "06", label: "June", year: prevYear },
    { value: "07", label: "July", year: prevYear },
    { value: "08", label: "Aug", year: prevYear },
    { value: "09", label: "Sep", year: prevYear },
    { value: "10", label: "Oct", year: prevYear },
    { value: "11", label: "Nov", year: prevYear },
    { value: "12", label: "Dec", year: prevYear },
    { value: "01", label: "Jan", year: currentYear },
    { value: "02", label: "Feb", year: currentYear },
    { value: "03", label: "Mar", year: currentYear },
    { value: "04", label: "Apr", year: currentYear },
    { value: "05", label: "May", year: currentYear },
    { value: "06", label: "June", year: currentYear }
  ]

  const [tabSelected, setTabSelected] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [eventCompleteList, setEventCompleteList] = useState("")

  console.log(eventCompleteList, "eventCompleteList")
  // console.log(tabSelected, "tabSelected")
  useEffect(() => {
    if (tabSelected === true) {
      dispatch(
        yearWiseEventsAction.loadEventCompleteList({
          year: monthDetails.year,
          month: monthDetails.value,
          limit: 100,
          page: 1,
        })
      )
      api
        .post("/list_lead_event_monthly_report", {
          year: monthDetails.year,
          month: monthDetails.value,
          limit: 100,
          page: 1,
        })
        .then((res) => {
          setTimeout(() => {
            //   let paginationNumber =
            //     !isEmpty(res.data.data) && res.data.data !== undefined
            //       ? res.data.data.totalPage
            //       : "--"

            //   // let pageNumberList = Math.round(paginationNumber)
            //   const result = [res.data.data.currentPage, paginationNumber]

            //   const range = (start, end) => {
            //     return Array(end - start + 1)
            //       .fill()
            //       .map((_, idx) => start + idx)
            //   }
            //   const pageNumber = !isEmpty(result)
            //     ? range(res.data.data.currentPage, paginationNumber)
            //     : "--"

            //   setPaginationList(pageNumber)
            const eventDataTable =
              !isEmpty(res.data.data) && res.data.data.data.length > 0
                ? res.data.data.data.map((eventData, index) => {
                  const eventDate =
                    !isEmpty(eventData.eventDate) && eventData.eventDate
                      ? moment(eventData.eventDate)
                        .subtract(5, "hours")
                        .subtract(30, "minutes")
                        .format(dateFormate)
                      : ""

                  if (
                    !isEmpty(eventData) &&
                    !isEmpty(eventData.serviceDetail) &&
                    eventData.serviceDetail.length > 0 &&
                    !serviceDetailsDataSet
                  ) {
                    setServiceDetailsData(eventData.serviceDetail)
                    setServiceDetailsDataSet(true)
                  }

                  return {
                    _id: eventData._id,
                    sNo: index + 1,
                    leadNo: eventData.leadNo,
                    name: eventData.clientName,
                    clientCode: eventData.clientCode,
                    bride: eventData.brideName,
                    groom: eventData.groomName,
                    eventDate: eventDate,
                    eventDateDetails: eventData.eventDate,
                    eventType: eventData.eventName,
                    priorityStatusId: eventData.priorityStatusId,
                    priorityStatusName: eventData.priorityStatusName,
                    startTime: eventData.startTime,
                    endTime: eventData.endTime,
                    food: eventData.food,
                    travelStay: eventData.travelStay,
                    venue: eventData.venueName,
                    location: eventData.venueLocation,
                    companyId: eventData.companyId,
                    ecAgentName: eventData.ecAgentName,
                    companyName: eventData.companyName,
                    branchId: eventData.branchId,
                    branchName: eventData.branchName,
                    salesAgent: eventData.salesAgent,
                    serviceDetail: eventData.serviceDetail,
                    shootType: eventData.shootType,
                    key: index,
                    clientType: eventData.clientType,
                    onlyEngagement: eventData.onlyEngagement,
                    goodLookingClient:eventData.goodLookingClient,
                    onlyEngagementStatus:eventData. onlyEngagementStatus,
                    highEndClient:eventData.highEndClient
                  }
                })
                : []
            // setPageSelected(false)
            // setBtnLoading(false)
            setEventDataTable(eventDataTable)
            setTabSelected(false)
          }, 4000)
          setEventCompleteList(res.data.data)
          res.data
        })
        .catch((error) => Promise.reject(error))

      setPageLoad(!pageLoad)
    }
  }, [tabSelected])

  // const monthInt = parseInt(monthDetails.value)
  // console.log(monthDetails, "monthDetails")
  // console.log(monthInt, "monthInt")

  //remote pagination section
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  // const [serviceData, setServiceData] = useState("")
  // const [serviceLoad, setServiceLoad] = useState(false)
  const exportToCsv = () => {
    var searchEmployee = employee && employee ? employee.empCode : ""
    var searchEventDate = eventDate
      ? moment(eventDate).format("YYYY-MM-DD")
      : ""
    var searchFreelancer = isFreelancer == true ? true : false

    var searchEventDateYear = eventDate
      ? moment(eventDate).format("YYYY")
      : !isEmpty(monthDetails)
        ? monthDetails.year
        : currentYear
    var searchEventDateMonth = eventDate
      ? moment(eventDate).format("MM")
      : !isEmpty(monthDetails)
        ? monthDetails.value
        : currentMonthDetails
    // var searchEventFromDate = eventFromDate
    //   ? moment(eventFromDate).format("YYYY-MM-DD")
    //   : ""
    var searchEventToDate = eventToDate
      ? moment(eventToDate).format("YYYY-MM-DD")
      : ""

    var searchValue = {}
    if (searchFreelancer) {
      searchValue.isFreelancer = searchFreelancer
    }
    if (searchEmployee) {
      searchValue.employeeCode = searchEmployee
    }
    if (searchEventDate) {
      searchValue.date = searchEventDate
    }
    // if (searchEventFromDate) {
    //   searchValue.eventFromDate = searchEventFromDate
    // }
    if (searchEventToDate) {
      searchValue.eventToDate = searchEventToDate
    }
    if (searchEventDateYear) {
      searchValue.year = searchEventDateYear
    }
    if (searchEventDateMonth) {
      searchValue.month = searchEventDateMonth
    }
    api
      .post(`list_lead_event_monthly_report_excel_export`, searchValue)
      .then((response) => {
        const eventDataTableList =
          !isEmpty(response.data) && response.data.data
            ? response.data.data.data.map((eventData, index) => {
              // console.log(response, "response")
              // slNo = slNo + 1

              if (
                !isEmpty(eventData) &&
                !isEmpty(eventData.serviceDetail) &&
                eventData.serviceDetail.length > 0 &&
                !serviceDetailsDataSet
              ) {
                setServiceDetailsData(eventData.serviceDetail)
                setServiceDetailsDataSet(true)
              }
              // console.log(serviceDetailsData, "myconsole")
              const eventDate =
                !isEmpty(eventData.eventDate) && eventData.eventDate
                  ? moment(eventData.eventDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate}`)
                  : ""
              const salesAgent = eventData.salesAgent
                ? JSON.stringify(eventData.salesAgent).replace(/","/g, "\n")
                : eventData.salesAgent

              const ecAgentName = eventData.ecAgentName
                ? JSON.stringify(eventData.ecAgentName).replace(/","/g, "\n")
                : eventData.ecAgentName

              const brideName = JSON.stringify(eventData.brideName).replace(
                /","/g,
                "\n"
              )
              const groomName = JSON.stringify(eventData.groomName).replace(
                /","/g,
                "\n"
              )
              const venueName = eventData.venueName
                ? JSON.stringify(eventData.venueName).replace(/","/g, "\n")
                : "--"
              // console.log(venueName, "venueName")
              const serviceDetails =
                !isEmpty(eventData.serviceDetail) &&
                eventData.serviceDetail.length > 0 &&
                eventData.serviceDetail.map((value) => ({
                  serviceCount: value.serviceCount,
                  teamInfo:
                    !isEmpty(value.teamShooterName) &&
                      value.teamShooterName.length > 0
                      ? value.teamShooterName
                        .map((shooter) => `(${shooter})`)
                        .join(" ")
                      : "",
                  designationInfo:
                    !isEmpty(value.teamShooterName) &&
                      !isEmpty(value.designationName) &&
                      value.designationName.length > 0
                      ? value.designationName
                        .map((designation) => `(${designation})`)
                        .join(" ")
                      : "",
                  freelancerInfo:
                    !isEmpty(value.freelancerMainShooter) &&
                      value.freelancerMainShooter.length > 0
                      ? value.freelancerMainShooter
                        .map((freelancer) => `(${freelancer})`)
                        .join(" ")
                      : "",
                }))
              const serviceDetailsValue =
                !isEmpty(serviceDetails) &&
                serviceDetails.map(
                  (detail) =>
                    `${detail.serviceCount} ${detail.teamInfo}${detail.designationInfo}${detail.freelancerInfo}`
                )
              return {
                _id: eventData._id,
                sNo: index + 1,
                name: !isEmpty(eventData.clientName)
                  ? eventData.clientName
                  : "--",
                bride: !isEmpty(eventData.brideName) ? brideName : "--",
                groom: !isEmpty(eventData.groomName) ? groomName : "--",
                eventDate: eventDate,
                eventType: eventData.eventType,
                eventName: eventData.eventName,
                priorityStatusId: eventData.priorityStatusId,
                priorityStatusName: eventData.priorityStatusName,
                startTime: eventData.startTime,
                endTime: eventData.endTime,
                food: eventData.food,
                travelStay: eventData.travelStay,
                venue: !isEmpty(eventData.venueName) ? venueName : "--",
                leadNo: eventData.leadNo,
                location: eventData.venueLocation,
                companyId: eventData.companyId,
                companyName: eventData.companyName,
                branchId: eventData.branchId,
                branchName: eventData.branchName,
                salesAgent: salesAgent,
                clientCode: eventData.clientCode ? eventData.clientCode : "",
                ecAgentName: !isEmpty(ecAgentName) ? ecAgentName : "--",
                // serviceDetail: eventData.serviceDetail,
                shootType: eventData.shootType,
                // serviceDetail:
                //   !isEmpty(eventData.serviceDetail) &&
                //   eventData.serviceDetail.length > 0 &&
                //   eventData.serviceDetail.map((value) => value.serviceCount),
                serviceDetail: serviceDetailsValue,
                key: index,
                clientType: eventData.clientType||"--",
                onlyEngagement: eventData.onlyEngagement == true ? "YES" : "NO",
                goodLookingClient:eventData.goodLookingClient == true ? "YES" : "NO",
                highEndClient:eventData.highEndClient == true ? "YES" : "NO",
              }
            })
            : []
        // console.log(eventDataTableList, "eventDataTableList")
        setBtnLoading(true)

        setTimeout(() => {
          let headerData = [
            `SNo,LeadNo,Client Code, Name,Client Type, Only Engagement,Good Looking Client,High End Client, Bride Name,Groom Name, Event Date,Event Name, Priority,Start Time, End Time, Venue, Food, Travel Stay, Location, Company, Branch, Sales Agent,Ec Agent, ${!isEmpty(serviceDetailsData)
              ? serviceDetailsData.map((value) => value.serviceName).join(",")
              : ""
            }`,
          ]

          let usersCsv =
            !isEmpty(eventDataTableList) &&
            eventDataTableList.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientCode,
                name,
                clientType,
                onlyEngagement,
                goodLookingClient,
                highEndClient,
                bride,
                groom,
                eventDate,
                eventName,
                priorityStatusName,
                startTime,
                endTime,
                venue,
                food,
                travelStay,
                location,
                companyName,
                branchName,
                salesAgent,
                ecAgentName,
                serviceDetail,
              } = user
              acc.push([
                sNo,
                leadNo,
                clientCode,
                name,
                clientType,
                onlyEngagement,
                goodLookingClient,
                highEndClient,
                bride,
                groom,
                eventDate,
                eventName,
                priorityStatusName,
                startTime,
                endTime,
                venue,
                food,
                travelStay,
                location,
                companyName,
                branchName,
                salesAgent,
                ecAgentName,
                serviceDetail,
              ])

              // console.log("test", acc)
              return acc
            }, [])
          // console.log(usersCsv, "usersCsv")
          const userDetails =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []
          downloadFile({
            data: [...headerData, ...userDetails].join("\n"),
            fileName: "YearWiseEventsRecord.csv",
            fileType: "text/csv",
          })
          // setDownloadLoading(false)
          setBtnLoading(false)
        }, 3500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  //Search bar functionality
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  // const [pageFreelancerLoad, setPageFreelancerLoad] = useState(false)

  const searchValueList =
    isFreelancer == true
      ? {
        year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
        month: !isEmpty(monthDetails)
          ? monthDetails.value
          : currentMonthDetails,
        searchFilter: searchInput,
        isFreelancer: true,
        limit: 100,
        page: pageNumber ? pageNumber : 1,
      }
      : {
        year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
        month: !isEmpty(monthDetails)
          ? monthDetails.value
          : currentMonthDetails,
        searchFilter: searchInput,
        limit: 100,
        page: pageNumber ? pageNumber : 1,
      }

  // console.log(isFreelancer, "isFreelancer")
  // console.log(searchValueList, "searchValueList")

  // console.log(searchInput, "searchInput")
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    setBtnLoading(true)

    // setTimeout(() => {
    dispatch(yearWiseEventsAction.loadEventCompleteList(searchValueList))
    api.post("list_lead_event_monthly_report", searchValueList).then((res) => {
      setTimeout(() => {
        // let paginationNumber =
        //   !isEmpty(res.data.data) && res.data.data !== undefined
        //     ? res.data.data.totalPage
        //     : "--"

        // const startPage =
        //   res.data.data.currentPage == 1
        //     ? paginationNumber - res.data.data.currentPage
        //     : parseInt(paginationNumber - res.data.data.currentPage + 1)

        // const result = [res.data.data.currentPage, paginationNumber]

        // const range = (start, end) => {
        //   return Array(end - start + 1)
        //     .fill()
        //     .map((_, idx) => start + idx)
        // }
        // const pagingNumber = !isEmpty(result)
        //   ? range(startPage, paginationNumber)
        //   : "--"
        // console.log(startPage, "startPage")

        // const pageNumber = startPage == 0 ? [1] : pagingNumber
        // setLastPage("")
        // setPaginationList(pageNumber)
        const eventDataTable =
          !isEmpty(res.data.data) && res.data.data.data.length > 0
            ? res.data.data.data.map((eventData, index) => {
              const eventDate =
                !isEmpty(eventData.eventDate) && eventData.eventDate
                  ? moment(eventData.eventDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(dateFormate)
                  : ""

              if (
                !isEmpty(eventData) &&
                !isEmpty(eventData.serviceDetail) &&
                eventData.serviceDetail.length > 0 &&
                !serviceDetailsDataSet
              ) {
                setServiceDetailsData(eventData.serviceDetail)
                setServiceDetailsDataSet(true)
              }

              return {
                _id: eventData._id,
                sNo: index + 1,
                leadNo: eventData.leadNo,
                name: eventData.clientName,
                clientCode: eventData.clientCode,
                bride: eventData.brideName,
                groom: eventData.groomName,
                eventDate: eventDate,
                eventDateDetails: eventData.eventDate,
                eventType: eventData.eventName,
                priorityStatusId: eventData.priorityStatusId,
                priorityStatusName: eventData.priorityStatusName,
                startTime: eventData.startTime,
                endTime: eventData.endTime,
                food: eventData.food,
                venue: eventData.venueName,
                travelStay: eventData.travelStay,
                location: eventData.venueLocation,
                companyId: eventData.companyId,
                ecAgentName: eventData.ecAgentName,
                companyName: eventData.companyName,
                branchId: eventData.branchId,
                branchName: eventData.branchName,
                salesAgent: eventData.salesAgent,
                serviceDetail: eventData.serviceDetail,
                shootType: eventData.shootType,
                key: index,
                clientType: eventData.clientType,
                onlyEngagement: eventData.onlyEngagement,
                goodLookingClient:eventData.goodLookingClient,
                onlyEngagementStatus:eventData. onlyEngagementStatus,
                highEndClient:eventData.highEndClient
              }
            })
            : []
        setEventDataTable(eventDataTable)
        setBtnLoading(false)
      }, 3500)
      setTimeout(() => {
        setSearchFilter(false)
      }, 1200)
      res.data
    })
    // }, 1000)
  }
  //Pagination section functionality

  // const [lastPage, setLastPage] = useState("")

  // useEffect(() => {
  //   if (eventLoading) {
  //     setTimeout(() => {
  //       let paginationNumber =
  //         !isEmpty(event_complete_details) &&
  //           event_complete_details !== undefined
  //           ? event_complete_details.totalPage
  //           : "--"

  //       let result = [event_complete_details.currentPage, paginationNumber]

  //       // const range = (start, end) => {
  //       //   return Array(end - start + 1)
  //       //     .fill()
  //       //     .map((_, idx) => start + idx)
  //       // }
  //       const range = (start, end) => {
  //         const length = Math.max(end - start + 1, 0)
  //         return Array.from({ length }, (_, idx) => start + idx)
  //       }
  //       const pageNumber = !isEmpty(result)
  //         ? range(event_complete_details.currentPage, paginationNumber)
  //         : "--"

  //       setLastPage("")
  //       setPaginationList(pageNumber)
  //     }, 6500)
  //   }
  // }, [eventLoading])

  // console.log(lastPage, "lastPage")

  //Page selection load

  useEffect(() => {
    if (pageSelected === true) {
      dispatch(
        yearWiseEventsAction.loadEventCompleteList({
          year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
          month: !isEmpty(monthDetails)
            ? monthDetails.value
            : currentMonthDetails,
          page: pageNumber,
          limit: 100,
        })
      )
      api
        .post("/list_lead_event_monthly_report", {
          year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
          month: !isEmpty(monthDetails)
            ? monthDetails.value
            : currentMonthDetails,
          page: pageNumber ? pageNumber : 1,
          limit: 100,
        })
        .then((res) => {
          setTimeout(() => {
            // let paginationNumber =
            //   !isEmpty(res.data.data) && res.data.data !== undefined
            //     ? res.data.data.totalPage
            //     : "--"

            // const startPage =
            //   res.data.data.currentPage == 1
            //     ? paginationNumber - res.data.data.currentPage
            //     : parseInt(paginationNumber - res.data.data.currentPage + 1)
            // // const startPage = parseInt(
            // //   paginationNumber - res.data.data.currentPage + 1
            // // )
            // // let pageNumberList = Math.round(paginationNumber)
            // const result = [res.data.data.currentPage, paginationNumber]

            // const range = (start, end) => {
            //   return Array(end - start + 1)
            //     .fill()
            //     .map((_, idx) => start + idx)
            // }
            // const pageNumber = !isEmpty(result)
            //   ? range(startPage, paginationNumber)
            //   : "--"

            // setPaginationList(pageNumber)
            const eventDataTable =
              !isEmpty(res.data.data) && res.data.data.data.length > 0
                ? res.data.data.data.map((eventData, index) => {
                  const eventDate =
                    !isEmpty(eventData.eventDate) && eventData.eventDate
                      ? moment(eventData.eventDate)
                        .subtract(5, "hours")
                        .subtract(30, "minutes")
                        .format(dateFormate)
                      : ""

                  if (
                    !isEmpty(eventData) &&
                    !isEmpty(eventData.serviceDetail) &&
                    eventData.serviceDetail.length > 0 &&
                    !serviceDetailsDataSet
                  ) {
                    setServiceDetailsData(eventData.serviceDetail)
                    setServiceDetailsDataSet(true)
                  }
                  return {
                    _id: eventData._id,
                    sNo: index + 1,
                    leadNo: eventData.leadNo,
                    name: eventData.clientName,
                    clientCode: eventData.clientCode,
                    bride: eventData.brideName,
                    groom: eventData.groomName,
                    eventDate: eventDate,
                    eventDateDetails: eventData.eventDate,
                    eventType: eventData.eventName,
                    priorityStatusId: eventData.priorityStatusId,
                    priorityStatusName: eventData.priorityStatusName,
                    startTime: eventData.startTime,
                    endTime: eventData.endTime,
                    food: eventData.food,
                    travelStay: eventData.travelStay,
                    venue: eventData.venueName,
                    location: eventData.venueLocation,
                    companyId: eventData.companyId,
                    ecAgentName: eventData.ecAgentName,
                    companyName: eventData.companyName,
                    branchId: eventData.branchId,
                    branchName: eventData.branchName,
                    salesAgent: eventData.salesAgent,
                    serviceDetail: eventData.serviceDetail,
                    shootType: eventData.shootType,
                    key: index,
                    clientType: eventData.clientType,
                    onlyEngagement: eventData.onlyEngagement,
                    goodLookingClient:eventData.goodLookingClient,
                    onlyEngagementStatus:eventData. onlyEngagementStatus,
                    highEndClient:eventData.highEndClient
                  }
                })
                : []
            setEventDataTable(eventDataTable)
          }, 4000)
          setEventCompleteList(res.data.data)
          res.data
        })
        .catch((error) => Promise.reject(error))
      setTimeout(() => {
        setBtnLoading(false)
        setPageSelected(false)
      }, 5000)
    }
  }, [pageSelected])

  // console.log(paginationList, "paginationList")
  // console.log(serviceDetailsData, "my testing")
  const clientEventUpdate = useSelector(
    (specificstate) => specificstate.myWorksCompleted
  )
  const { clientEvent_data = [] } = clientEventUpdate

  const [clientEventModal, setClientEventModal] = useState(false)
  const loadClientEvent = (payload) => {
    setClientEventModal(true)
    const payloadData = {
      clientNo: payload,
    }
    setTimeout(() => {
      dispatch(eventClientAction.loadClientEvent(payloadData))
    })
  }

  //Data Table section
  const clientDataTable = !isEmpty(clientEvent_data)
    ? clientEvent_data.map((data, index) => {
      //////////////
      const eventName = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventName).join(",")
        : "--"
      const eventNo = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventNo).join(",")
        : "--"
      const eventDate = !isEmpty(data.eventDetails)
        ? data.eventDetails
          .map((m) => moment(m.eventDate).format(dateFormate))
          .join(",")
        : "--"
      const startTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.startTime).join(",")
        : "--"
      const endTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.endTime).join(",")
        : "--"
      const venue = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.venueLocation).join(",")
        : "--"
      return {
        index: index,
        key: index,
        leadId: data.leadId,
        leadNo: data.leadNo,
        sNo: index + 1,
        serviceCount: !isEmpty(data.serviceDetails)
          ? data.serviceDetails.length
          : 0,
        isCommit: data.isCommit,
        eventName: eventName,
        eventNo: eventNo,
        eventDate: eventDate,
        startTime: startTime,
        endTime: endTime,
        venueLocation: venue,
        serviceDetails: data.serviceDetails,
      }
    })
    : []

  //table columns
  const clientColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return <span>{row.leadNo}</span>
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const clientExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                File Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Size
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              !isEmpty(row.serviceDetails) &&
              row.serviceDetails.length > 0 ? (
              row.serviceDetails.map((data, index) => {
                const serviceName = !isEmpty(data.serviceId)
                  ? data.serviceId.serviceName
                  : "--"
                const freelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceMainShooterName
                    )
                    : []

                const freelancerName =
                  !isEmpty(freelancer) && freelancer.length > 0
                    ? freelancer.join(",")
                    : "--"

                const subFreelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceSubShooterName
                    )
                    : []

                const subFreelancerName =
                  !isEmpty(subFreelancer) && subFreelancer.length > 0
                    ? subFreelancer.join(",")
                    : "--"

                const shooterName = !isEmpty(data.teamEmployeeShooterId)
                  ? data.teamEmployeeShooterId.empCode +
                  "-" +
                  data.teamEmployeeShooterId.name
                  : "--"
                return (
                  <tr key={index}>
                    <td>{data.serviceNo ? data.serviceNo : "--"}</td>
                    <td>{serviceName}</td>
                    <td>{shooterName}</td>
                    <td>{freelancerName}</td>
                    <td>{subFreelancerName}</td>
                    <td>
                      {data.serviceLevelStatusName
                        ? data.serviceLevelStatusName
                        : "--"}
                    </td>
                    <td>{data.fileCount ? data.fileCount : "--"}</td>
                    <td>{data.size ? data.size : "--"}</td>
                    <td>{data.remarks ? data.remarks : "--"}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={8}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  // pagination options
  const clientOptions = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="3" lg="3" xl="3" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Event From Date"}
                      </Label>
                      <Input
                        type="date"
                        name="eventDate"
                        value={eventDate}
                        onChange={(e) => setEventDate(e.target.value)}
                        className="form-control"
                      />
                    </Col>{" "}
                    {/* <Col md="3" lg="3" xl="3" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Event From Date"}
                      </Label>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={eventFromDate}
                        onChange={(e) => setEventFromDate(e.target.value)}
                        className="form-control"
                      />
                    </Col>{" "} */}
                    <Col md="3" lg="3" xl="3" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Event To Date"}
                      </Label>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={eventToDate}
                        onChange={(e) => setEventToDate(e.target.value)}
                        className="form-control"
                      />
                    </Col>{" "}
                    <Col xl="3" lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Shooter"}
                      </Label>
                      <ReactSearchAutocomplete
                        key={resetEmployee}
                        name="employee"
                        items={
                          recordsMetaData.employeeListOptions
                            ? recordsMetaData.employeeListOptions
                            : []
                        }
                        value={employee}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onClear={handleOnClear}
                        onSelect={(e) => setEmployee(e)}
                        onChange={(e) => setEmployee(e.target.value)}
                        placeholder="Enter Shooter"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-5">
                      <div className="d-flex flex-row">
                        {statusList.map((status, index) => {
                          return (
                            <div className="d-flex flex-row" key={index}>
                              <Input
                                type="checkbox"
                                name="isFreelancer"
                                value={status.value}
                                checked={isFreelancer === status.value}
                                // className={status.value ? "audit-status-border" : ""}
                                onChange={(e) =>
                                  handleStatusChange(e, status.value)
                                }
                                className="font-size-15"
                              />
                              <Label
                                className="mx-2"
                                style={{ marginTop: "2px", fontSize: "12px" }}
                              >
                                {status.label}
                              </Label>
                            </div>
                          )
                        })}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col lg="12" md="12" sm="12" xs="12">
                      <div
                        className="d-flex flex-row"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => resetForm()}
                          className="btn btn-danger btn-label simple-form-Reset-btn"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => applyFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="12" lg="12" xl="12">
                      <div
                        className="d-flex flex-row"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                          <form
                            onSubmit={handleClick}
                            className="d-flex flex-row"
                          >
                            <div style={searchBarStyle || null}>
                              <Input
                                type="text"
                                name="searchInput"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                className="form-control"
                                placeholder="Search"
                                style={{ position: "relative" }}
                              />
                              <i
                                className="bx bx-search-alt"
                                style={{
                                  position: "absolute",
                                  top: "33px",
                                  left: "35px",
                                  fontSize: "13px",
                                }}
                              />
                            </div>
                            <button
                              className="btn btn-success mx-2"
                              type="submit"
                              style={{
                                background: searchFilter ? "#2ca67a" : "",
                                color: searchFilter ? "#ffffff" : "",
                              }}
                            // onClick={(e) => handleClick()}
                            >
                              <i className="fas fa-search"></i>
                            </button>
                          </form>
                        </div>
                      </div>{" "}
                      <div style={{ marginBottom: "20px", marginTop: "-44px" }}>
                        <Button
                          className="border float-right mx-10"
                          style={{
                            float: "right",
                            backgroundColor: "#e40d8c",
                            color: "#ffffff",
                          }}
                          onClick={exportToCsv}
                        >
                          Download{" "}
                        </Button>{" "}
                      </div>
                    </Col>
                    <Col md="12" lg="12" xl="12" className="mt-3">
                      <Nav
                        className="nav-tabs-custom nav-justified mb-3"
                      // style={{ marginBottom: "-1px" }}
                      >
                        {tabs.map((tab, tabIndex) => {
                          return (
                            <NavItem key={tabIndex}>
                              <NavLink
                                style={
                                  (customIconActiveTab === tab.label &&
                                    tab.year == prevYear &&
                                    tab.year == customIconActiveYear) ||
                                    (customIconActiveTab === tab.label &&
                                      tab.year == currentYear &&
                                      tab.year == customIconActiveYear) ||
                                    (customIconActiveTab === tab.label &&
                                      tab.year == nextYear &&
                                      tab.year == customIconActiveYear)
                                    ? {
                                      cursor: "pointer",
                                      color: "#000000",
                                      fontWeight: 600,
                                      backgroundColor: "#ffffff",
                                      borderRight:
                                        tab.label === "Dec"
                                          ? ""
                                          : "1px solid #c7c7c7",
                                      borderLeft:
                                        tab.label === "Jan"
                                          ? ""
                                          : "1px solid #c7c7c7",
                                    }
                                    : {
                                      cursor: "pointer",
                                      color: "#ad9f9f",
                                      fontWeight: 600,
                                      backgroundColor: "#f7f7f7",
                                      borderBottom: "1px solid #c7c7c7",
                                    }
                                }
                                onClick={() => {
                                  setMonthDetails(tab)
                                  setTabSelected(true)
                                  setCustomIconActiveTab(tab.label)
                                  setCustomIconActiveYear(tab.year)
                                  setBtnLoading(true)
                                  setTimeout(() => {
                                    setBtnLoading(false)
                                    setTabSelected(false)
                                  }, 5000)
                                }}
                              >
                                <span className="tabs-content d-none d-sm-block">
                                  {tab.label}
                                  {"-" + tab.year}
                                </span>
                              </NavLink>
                            </NavItem>
                          )
                        })}
                      </Nav>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" lg="12" xl="12">
                      <Table responsive bordered onScroll={true}>
                        <thead className="header-class">
                          <tr>
                            <th
                              style={{
                                position: "sticky",
                                top: 0,
                                left: 0,
                                zIndex: 2,
                                minWidth: "50px",
                              }}
                            >
                              S.No
                            </th>
                            <th
                              style={{
                                // borderRight: "1px solid #e1e1e1",
                                // borderBottom: "1px solid #e1e1e1",
                                position: "sticky",
                                top: 0,
                                left: "50px",
                                zIndex: 2,
                                minWidth: "100px",
                              }}
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleLeadSort()}
                              >
                                <p>Lead No</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "140px",

                              }}
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleClientCodeSort()}
                              >
                                <p>Client Code</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "100px",

                              }}
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleNameSort()}
                              >
                                <p>Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "140px",

                              }}

                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBrideSort()}
                              >
                                <p>Client Type</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "180px",

                              }}

                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBrideSort()}
                              >
                                <p>Only Engagement</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "180px",

                              }}

                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBrideSort()}
                              >
                                <p>Good Looking Client</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>

                            <th
                              style={{
                                minWidth: "180px",

                              }}

                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBrideSort()}
                              >
                                <p>High End Client</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "140px",

                              }}

                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBrideSort()}
                              >
                                <p>Bride Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "140px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleGroomSort()}
                              >
                                <p>Groom Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "140px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleDateSort()}
                              >
                                <p>Event Date</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "140px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleEventSort()}
                              >
                                <p>Event Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "120px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handlePrioritySort()}
                              >
                                <p>Priority</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "120px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                              >
                                <p> Start Time</p>
                                <p onClick={() => handleSort()}>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "120px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                              >
                                <p>End Time</p>
                                <p onClick={() => handleSort()}>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "120px",

                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleVenueSort()}
                              >
                                <p>Venue</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "120px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleFoodSort()}
                              >
                                <p>Food</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "120px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleTravelSort()}
                              >
                                <p>Travel Stay</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "100px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleLocationSort()}
                              >
                                <p>Location</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "100px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleCompanySort()}
                              >
                                <p>Company</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "100px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBranchSort()}
                              >
                                <p>Branch</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "125px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleSalesSort()}
                              >
                                <p>Sales Agent</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th
                              style={{
                                minWidth: "125px",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                              >
                                <p>Ec Agent</p>
                                <p onClick={() => handleEcSort()}>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>

                            {!isEmpty(serviceDetailsData) &&
                              serviceDetailsData.length > 0
                              ? Object.entries(serviceDetailsData).map(
                                ([key, value]) => {
                                  return (
                                    <th
                                      style={{
                                        minWidth: "140px",
                                      }}
                                      // className="fixed-header"
                                      key={key}
                                    >
                                      {value.serviceName}
                                    </th>
                                  )
                                }
                              )
                              : []}
                          </tr>
                        </thead>
                        <tbody>
                          {!isEmpty(eventsDataTable) &&
                            eventsDataTable.length > 0 ? (
                            eventsDataTable.map((data, index) => {
                              // console.log(data.ecAgentName, "ecAgentName")
                              // console.log(data, "datai")
                              return (
                                <tr key={index} className="font-size-10">
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      position: "sticky",
                                      top: 0,
                                      left: 0,
                                      zIndex: 2,
                                    }}
                                  >
                                    {data.sNo}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      position: "sticky",
                                      top: 0,
                                      left: "50px",
                                      zIndex: 2,
                                      color: "#e40d8c",
                                    }}
                                  >
                                    {!isEmpty(data.leadNo) ? data.leadNo : "--"}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      color: "#e40d8c",

                                    }}
                                  >
                                    <a
                                      onClick={() =>
                                        loadClientEvent(data.clientCode)
                                      }
                                    >
                                      {!isEmpty(data.clientCode)
                                        ? data.clientCode
                                        : ""}
                                    </a>
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {!isEmpty(data.name) ? data.name : "--"}
                                  </td>
                                  {/* cliet type */}
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      justifyContent: "center"
                                    }}
                                  >
                                    {data.clientType ? <span
                                      className={"badge"}
                                      style={{
                                        backgroundColor: data.clientType == "Green" ? "#28a745" :
                                          data.clientType == "Yellow" ? "#fce303" :
                                            data.clientType == "Orange" ? "#FFA500" :
                                              data.clientType == "Blue" ? "#033dfc" : "",
                                        display: "inline-block",
                                        width: "35px",        // Equal width and height for a circle
                                        height: "35px",
                                        borderRadius: "50%",
                                      }}
                                    /> : "--"}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      justifyContent: "center"
                                    }}
                                  >
                                    {data.onlyEngagement === true ? (
                                      <span
                                        className="badge"
                                        style={{
                                          display: "inline-block",
                                          width: "35px",
                                          height: "35px",
                                          borderRadius: "50%",
                                          color: "#c5ff00",
                                          backgroundColor: "#c5ff00",
                                        }}
                                      />
                                    ) : (
                                      "--"
                                    )}
                                    {data.onlyEngagementStatus ? ` (${data.onlyEngagementStatus})` : ""}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      justifyContent: "center"
                                    }}
                                  >
                                    {data.goodLookingClient === true ? (
                                      <span
                                        className="badge"
                                        style={{
                                          display: "inline-block",
                                          width: "35px",
                                          height: "35px",
                                          borderRadius: "50%",
                                          color: "#FFD700",
                                          backgroundColor: "#BF55EC"
                                        }}
                                      />
                                    ) : (
                                      "--"
                                    )}

                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      justifyContent: "center"
                                    }}
                                  >
                                    {data.highEndClient === true ? (
                                      <span
                                        className="badge"
                                        style={{
                                          display: "inline-block",
                                          width: "35px",
                                          height: "35px",
                                          borderRadius: "50%",
                                          color: "#BF55EC",
                                          backgroundColor: "#FFD700"
                                        }}
                                      />
                                    ) : (
                                      "--"
                                    )}

                                  </td>
                                  {/*  */}
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {!isEmpty(data.bride) ? data.bride : "--"}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {!isEmpty(data.groom) ? data.groom : "--"}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {data.eventDate}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {data.eventType}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {data.priorityStatusName}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",

                                    }}
                                  >
                                    {data.startTime}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",

                                    }}
                                  >
                                    {data.endTime}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",

                                    }}
                                  >
                                    {data.venue}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {data.food}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {data.travelStay}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {data.location}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {data.companyName}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {data.branchName}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {data.salesAgent}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: data.ecAgentName
                                        ? "#3abd856e"
                                        : "#4486eb1f",
                                    }}
                                  >
                                    {!isEmpty(data.ecAgentName)
                                      ? data.ecAgentName
                                      : "--"}
                                  </td>
                                  {/* <td>{data.shootType}</td> */}
                                  {!isEmpty(data) &&
                                    data.serviceDetail.length > 0
                                    ? Object.entries(data.serviceDetail).map(
                                      ([key, value]) => {
                                        return (
                                          <td
                                            style={{
                                              minWidth: "140px",
                                              backgroundColor:
                                                data.ecAgentName
                                                  ? "#3abd856e"
                                                  : "#4486eb1f",
                                            }}
                                            key={key}
                                          >
                                            <div
                                              className="d-flex flex-row"
                                              style={{ marginBottom: "-4px" }}
                                            >
                                              <h6
                                                style={{
                                                  fontSize: "10px",
                                                }}
                                              >
                                                {value.serviceCount}{" "}
                                              </h6>
                                              <div className="mx-1">
                                                <p
                                                  style={{
                                                    color: "#e40d8c",
                                                    fontSize: "10px",
                                                    marginBottom: "-2px",
                                                  }}
                                                >
                                                  {!isEmpty(
                                                    value.teamShooterName
                                                  ) &&
                                                    value.teamShooterName
                                                      .length > 0
                                                    ? `(${value.teamShooterName})(${value.designationName})`
                                                    : ""}
                                                </p>
                                                <p
                                                  style={{
                                                    color: "#50a5f1",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  {!isEmpty(
                                                    value.freelancerMainShooter
                                                  ) &&
                                                    value.freelancerMainShooter
                                                      .length > 0
                                                    ? `(${value.freelancerMainShooter})`
                                                    : ""}
                                                </p>
                                              </div>
                                            </div>
                                          </td>
                                        )
                                      }
                                    )
                                    : []}
                                </tr>
                              )
                            })
                          ) : (
                            <tr key={0}>
                              <td
                                className="text-align-center"
                                colSpan={17}
                              ></td>
                            </tr>
                          )}
                          <tr></tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col md="12" lg="12" xl="12" className="mt-3">
                      <div className="d-flex flex-row justify-content-end">
                        <Pagination>
                          {!isEmpty(paginationList) && paginationList.length > 0
                            ? paginationList.map((data, index) => {
                                return (
                                  <>
                                    <PaginationItem key={index}>
                                      <PaginationLink
                                        href="#"
                                        onClick={() => {
                                          setPageNumber(data)
                                          setPageSelected(true)
                                          setBtnLoading(true)
                                        }}
                                        style={{
                                          background:
                                            data == pageNumber
                                              ? "#e40d8c"
                                              : "#ffffff",
                                          color:
                                            data == pageNumber
                                              ? "#ffffff"
                                              : "#000000",
                                        }}
                                      >
                                        {data}
                                      </PaginationLink>
                                    </PaginationItem>
                                  </>
                                )
                              })
                            : ""}
                        </Pagination>
                      </div>
                    </Col> */}
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {btnLoading ? (
              <Modal
                show={btnLoading}
                style={{ width: "6.8%", margin: "21% 50%" }}
              >
                <Modal.Body>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                    variant="success"
                    className="mx-2"
                    color="success"
                  />
                  {/* <span>Loading...</span> */}
                </Modal.Body>
              </Modal>
            ) : (
              ""
            )}
            {clientEventModal && (
              <Modal size="xl" show={clientEventModal}>
                <Modal.Header
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Event
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md="12" lg="12" xl="12" className="mt-3">
                      <PaginationProvider
                        pagination={paginationFactory(clientOptions)}
                        keyField="index"
                        columns={clientColumns}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="index"
                            data={clientDataTable}
                            columns={clientColumns}
                            search
                            exportCSV
                          >
                            {(props) => (
                              <div>
                                <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                  <Row className="d-flex flex-row  ">
                                    <Col>
                                      <BootstrapTable
                                        {...props.baseProps}
                                        responsive
                                        striped={true}
                                        bordered={true}
                                        keyField="index"
                                        expandRow={clientExpandRow}
                                        columns={clientColumns}
                                        {...paginationTableProps}
                                      />
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{ marginTop: "5px" }}
                                    className="align-items-md-center mt-30"
                                  >
                                    <Col className="inner-custom-pagination d-flex">
                                      <div className="d-inline d-flex flex-row">
                                        <SizePerPageDropdownStandalone
                                          {...paginationProps}
                                        />
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginTop: "8px",
                                            marginLeft: "4px",
                                          }}
                                        >
                                          <PaginationTotalStandalone
                                            {...paginationProps}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className="text-md-right ms-auto"
                                        style={{ zIndex: 0 }}
                                      >
                                        <PaginationListStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </div>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={() => setClientEventModal(false)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

YearWiseEventsRecord.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  paginationProps: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}


const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(YearWiseEventsRecord)
)

